import React, { useEffect } from 'react'
import styled from "styled-components"
import pic from "./Images/1.jpg"
import Aos from 'aos';
import "aos/dist/aos.css"

const About = () => {

  useEffect(()=>{
    Aos.init({
      duration: 2000
    })
  }, [])

  return (
    <Container>
      <H1>ABOUT ME</H1>
      <Wrapper>
        <Left data-aos="zoom-in"></Left>
        <Right>
        <p >
        I am Oguamanam Cynthia a fullstack software developer with 2 year experience in frontend and backend development, expertise in frontend development. I am driven by my passion of bringing to life ideas through technology. <br/><br/>
        Considering myself a forever student who is ever ready to learn new tech skills, innovations and more in the tech space to enhance more productivity in bringing ideas to life. <br/><br/>

        Speaking of bringing ideas to life, the first of it's kind in Ajegunle, Lagos Nigeria tagged Ajegunle Tech Fair: Birth of unicorns.My team and I built a product E-medi.
        An online consultancy application that also helps people new at a given area to locate good pharmacies and hospitals in case of emergencies. <br/><br/>Got my first job after the tech fair to train young women on frontend software development at the prestigious Mamamoni Empowerment Foundation.<br/><br/>

        I am currently working with the above mentioned company and open for<br/> freelancing, remote and hybrid jobs.
        I believe in the power of team work so I look forward to working with your team to bring ideas to life. I am interested in any challenge, task or project. Reach out to me on <a href="https://oguamanamcynthia.netlify.app/dev/about">Contact_me</a> to connect.
        </p>
        </Right>
      </Wrapper>
    </Container>
  )
};

export default About;


const Container = styled.div`
width: 100%;
height: 85vh;
background-color: black;
display: flex;
flex-direction: column;
align-items: center;
padding-top: 100px;

@media Screen and (max-width: 768px){
  height: max-content;
}
`;
const Wrapper = styled.div`
width: 90%;
height: 80%;
display: flex;
justify-content: space-between;
align-items: center;

@media Screen and (max-width: 768px){
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
}
`;

const H1 = styled.h1`
font-size: 35px;
text-decoration:underline double black 1px;
color:whitesmoke;

`;

const Left = styled.div`
width: 45%;
height: 100%;
background-image: url(${pic});
background-size: cover;
background-repeat: no-repeat;
border-radius: 10px;
@media Screen and (max-width: 768px){
  width: 90%;
  height: 80vh;
}
@media Screen and (max-width: 425px){
  width: 95%;
  height: 70vh;
  background-position: center;
}
`;
const Right = styled.div`
width: 45%;
height: 100%;
display: flex;
justify-content: center;
align-items: center;
font-size: 17px;
color:whitesmoke;

/* background-color: purple; */

@media Screen and (max-width: 768px){
  width: 90%;
}
`;